import { rw, fs, rh, rgba } from "core/designHelpers";
import React, { useEffect, useState } from "react";
import { Image, Keyboard, Modal, ScrollView, StyleSheet, Text, TextInput, TouchableOpacity, View } from "react-native";
import { TextFieldProps } from "./TextField";
import dropdown_svg from 'res/svgs/dropdown.svg'
import StyleSheetRW from "core/StyleSheetRW";
import Pic from "core/Pic";
export interface DropDownFieldProps extends TextFieldProps {
    options: Array<string | { id: string; title: string }>;
    label?: string;
    isObjectList?: boolean;
    isCloseOnSelection?: boolean;
    showSearchBar?: boolean;
}


export default function DropDownField({ showSearchBar = false, isObjectList = false,isCloseOnSelection = false,options,label, onChangeText, ...props }: DropDownFieldProps) {
    const [visible, setVisible] = useState(false);
    const [value, setValue] = useState(props.value);

    useEffect(() => {
        setValue(props.value)
    }, [props.value])

    return (
        <View style={{ width: '100%'}}>
            <View style={styles.inputContainer}>
                <TouchableOpacity
                    onPress={() => setVisible(true)}
                    disabled={props.editable === false}
                >
                    <TextInput {...props}
                        value={value}
                        editable={false}
                        style={styles.input}
                        onTouchStart={() => setVisible(true)}
                    />
                    <View style={styles.overlay}>
                        <View style={styles.eyeIcon}>
                            <Pic source={dropdown_svg} style={{ width: "15px", height: "15px",marginTop:8 }} />
                        </View>
                    </View>
                </TouchableOpacity>
            </View>

            <PickerModal
                options={options}
                visible={visible}
                onClose={(selectedOption?: string | { id: string; title: string }) => {
                    if (selectedOption) {
                        const displayValue = isObjectList ? (selectedOption as { id: string; title: string }).title : (selectedOption as string);
                        const returnValue = isObjectList ? (selectedOption as { id: string; title: string }) : selectedOption;
                        setValue(displayValue);
                        onChangeText!(returnValue);
                    }
                    setVisible(false);
                }}
                label={label}
                isObjectList={isObjectList}
                isCloseOnSelection={isCloseOnSelection}
                showSearchBar={showSearchBar}
            />
        </View>
    );
}

function PickerModal(props: {showSearchBar:boolean , isCloseOnSelection: boolean, visible: boolean, onClose: (option?: string | { id: string; title: string }) => void, options: Array<string | { id: string; title: string }>, label: any, isObjectList: boolean }) {

    const [visible, setVisible] = useState(props.visible)
    const [selectedOption, setSelectedOption] = useState<string | { id: string; title: string } >();
    const [searchText, setSearchText] = useState("")
    const [filteredOptions, setFilteredOptions] = useState(props.options)
    // const [value, setValue] = useState("")
    useEffect(() => {
        setFilteredOptions(props.options)
    }, [props.options])
    useEffect(() => {
        if (searchText.length > 0) {
            setFilteredOptions(props.options.filter(option => {
                if (props.isObjectList) {
                    return (option as { title: string }).title.toLowerCase().includes(searchText.toLowerCase())
                } else {
                    return (option as string).toLowerCase().includes(searchText.toLowerCase())
                }
            }))
        } else {
            setFilteredOptions(props.options)
        }
    }, [searchText])

    useEffect(() => {
        setVisible(props.visible)
    }, [props.visible])

    useEffect(() => {
        if (visible) Keyboard.dismiss()
    }, [visible])

    const handleClose = (option?: string | { id: string; title: string }) => {
        if(props.isCloseOnSelection){
            setSelectedOption(option)
        }
        props.onClose(option);
        setVisible(false);
    };

    return (
        <Modal
            animationType="fade"
            transparent={true}
            visible={visible}
            onRequestClose={() => {
                setVisible(!visible)
            }}
        >
            <View style={{ flex: 1, justifyContent: "center", alignItems: "center", backgroundColor: "rgba(0,0,0,0.5)" }}>
                <View style={{ backgroundColor: "white", width: rw(343), maxHeight: '60%', borderRadius: 25, overflow: "hidden" }}>
                    {props.showSearchBar && <TextInput style={{ padding: rw(20), fontSize: fs(18), borderBottomWidth: 1, borderBottomColor: rgba(0, 0, 0, 0.6), outline: "none" }} placeholder="Search" 
                        onChangeText={setSearchText} 
                        value={searchText} 
                         />}
                    <ScrollView showsVerticalScrollIndicator={false} >
                        {filteredOptions.map(option => {
                            return (
                                <Text
                                    onPress={props.isCloseOnSelection === true ? () => handleClose(option) : () => setSelectedOption(option)}
                                    key={props.isObjectList ? (option as { id: string }).id : option as string}
                                    style={{
                                        fontFamily: "Outfit",
                                        fontSize: fs(18),
                                        flex: 1,
                                        paddingLeft: rw(20),
                                        backgroundColor: option !== selectedOption ? undefined : 'rgba(0,0,0,0.1)',
                                        paddingVertical: rh(20),
                                        color: 'black'
                                    }}
                                >
                                {props.isObjectList ? (option as { title: string }).title : option as string}
                            </Text>
                                // <Text onPress={props.label === "Gender" ? () => handleGenderClose(o) : () => setValue(o)} key={o} style={{ fontFamily: "Outfit", fontSize: fs(18), flex: 1, paddingLeft: rw(20), backgroundColor: o !== value ? undefined : 'rgba(0,0,0,0.1)', paddingVertical: rh(20), color: 'black' }}>{o}</Text>
                            );
                        })}
                    </ScrollView>

                     <View style={{ flexDirection: "row", justifyContent: "space-evenly" }}>
                        <Text onPress={() => handleClose()} style={{ fontFamily: "Outfit", fontSize: fs(18), flex: 1, textAlign: "center", backgroundColor: 'rgba(0,0,0,0.05)', paddingVertical: rh(20) }}>Cancel</Text>
                        <Text onPress={() => handleClose(selectedOption || undefined)} style={{ fontFamily: "Outfit", fontSize: fs(18), flex: 1, textAlign: "center", paddingVertical: rh(20) }}>Done</Text>
                    </View>
                </View>
            </View>
        </Modal>
    );
}



const styles = StyleSheetRW.create(() => ({
    inputContainer: {
        position: 'relative',
        width: '30%',
    },
    input: {
        height: '36px',
        borderRadius: 10,
        paddingHorizontal: 10,
        backgroundColor: '#0000000D',
        marginVertical: 6,
        cursor:"pointer"
    },
    overlay: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        justifyContent: 'center',
        paddingHorizontal: 10,
    },
    eyeIcon: {
        height: 24,
        width: 24,
    },
}))

export const DropDownOptionsStates =
    ["Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "District of Columbia", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"]
        .sort();